import React from 'react';

import { Badge as UCLBadge, makeUclComponent } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import Picture from 'components/picture';
import { Box, BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';
export const thumbnailSize = {
  width: spacing.$17_5,
  height: spacing.$13_5,
};

export const ItemThumbnailContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.itemThumbnailContainer, style] });

export const ThumbnailBox = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.thumbnailBox, style] });

export const ThumbnailBehind = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.thumbnailBehind, style] });

export const BadgeContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.badgeContainer, style] });

export const Badge = UCLBadge.withConfig({
  width: '$5',
  height: '$5',
  style: {
    minWidth: 'auto',
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
  },
});

export const StyledPicture = makeUclComponent(Picture).withConfig({
  width: spacing.$13_5,
  height: spacing.$13_5,
});

const styles = StyleSheet.create({
  itemThumbnailContainer: { ...thumbnailSize, alignItems: 'center' },
  thumbnailBox: {
    ...thumbnailSize,
    alignItems: 'center',
    backgroundColor: primitive.$greyEleven,
    borderRadius: primitive.$borderRadius,
    elevation: 1,
    position: 'absolute',
    shadowOpacity: 0.2,
    shadowRadius: 6,
  },
  thumbnailBehind: {
    ...thumbnailSize,
    alignItems: 'center',
    backgroundColor: primitive.$greyEleven,
    borderRadius: primitive.$borderRadius,
    elevation: 1,
    position: 'absolute',
    shadowOpacity: 0.3,
    shadowRadius: 2,
  },
  badgeContainer: {
    bottom: spacing.$2_5,
    height: spacing.$5,
    left: spacing.$13_5,
    position: 'absolute',
    width: spacing.$5,
    zIndex: 1,
  },
});
